import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/Config.js";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { PhoneInput, defaultCountries } from "react-international-phone";
import "react-international-phone/style.css";

const indiaOnlyCountries = defaultCountries.filter(
  (country) => country[1] === "in"
);

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    mobile: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch(); 

  const [numbererrormessage, setnumbererrormessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const normalizeAndValidateIndianMobile = (input) => {
    if (!input) return { isValid: false, mobile: '' };
  
    // remove spaces, hyphens, brackets, etc.
    let digits = String(input).replace(/\D/g, '');
  
    // remove country code 91 if present
    if (digits.startsWith('91')) {
      digits = digits.slice(2);
    }
  
    // remove leading zero
    if (digits.startsWith('0')) {
      digits = digits.slice(1);
    }
  
    // must be exactly 10 digits
    if (!/^[6-9]\d{9}$/.test(digits)) {
      return { isValid: false, mobile: '' };
    }
  
    return { isValid: true, mobile: digits };
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    var ismobileerror = false;

    if (!formData.mobile) {
      // alert("Mobile Number is mandatory");
      ismobileerror = false;
      setnumbererrormessage("Mobile Number is mandatory");
      return;
    } else {
      if(formData.mobile?.length < 4) {
        ismobileerror = false;
        setnumbererrormessage("Mobile Number is mandatory");
        return;
      } else {
        setnumbererrormessage("");
        ismobileerror = true;
      }
      
    }
    const { isValid, mobile } = normalizeAndValidateIndianMobile(formData.mobile);
    if (!isValid) {
      ismobileerror = false;
      setnumbererrormessage("Invalid mobile number");
      return;
    } else {
      setnumbererrormessage("");
      ismobileerror = true;
    }

    setLoading(true);
    var data = {
      mobile: mobile
    }
    console.log('data >>', data);

    try {
      const res = await axios.post(
        apiUrl + "sendotptoregisternumber",
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        // dispatch({ type: "customerdata", payload: res.data.data })
        // navigate("/createstory");
        const user = {
          mobile: formData.mobile,
        };
        navigate("/verify-otp-with-mobilenumber", { state: user });
      } else {
        alert(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        {/* Canonical Tag */}
        <link rel="canonical" href="https://theomsaga.com/login" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Login to TheOmSaga | Share Your Spiritual Stories"
        />
        <meta
          property="og:description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />
        <meta property="og:url" content="https://theomsaga.com/login" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/login-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
        </script>
      </Helmet>

      <div className="login-page-container">
        <div className="login-page-scroll">
          <div className="login-page-main-content">
            <div>
              <p className="onetime-text-login">
                One-time Registration fee with lifetime access.
              </p>
              <p className="login-page-title">Log In to Your Account</p>
            </div>

            <form className="login-page-form" onSubmit={handleSubmit}>
              {/* <input
              className="login-page-input"
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
            /> */}
              <PhoneInput
                defaultCountry="in"
                countries={indiaOnlyCountries}
                hideDropdown
                forceDialCode
                disableCountryGuess
                placeholder="Telephone"
                name="mobile"
                value={formData.mobile}
                onChange={(e) => {
                  setFormData({ ...formData, mobile: e });
                }}
                style={{marginBottom: 15}}
              />
              {
                numbererrormessage ?
                <p className="register-error-message" style={{textAlign: 'center'}}>{numbererrormessage}</p> : null
              }
              <button
                className="login-page-button"
                type="submit"
                disabled={loading}
              >
                {loading ? "Sending otp..." : "Generate OTP"}
              </button>

              <div className="ormaindiv">
                <div className="orborder"></div>
                <div className="ortextdiv">
                  <p className="ortext">OR</p>
                </div>
                <div className="orborder"></div>
              </div>

              <button
                className="login-page-button loginwithpasswordbtn"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/login-with-password');
                  console.log('Hello')
                }}
              >
                 Login with Password 
              </button>
            </form>

            <div className="login-page-mantra">
              <p>
                Don't have an account? <br />
                <button
                  type="button"
                  className="login-page-registerlink"
                  onClick={handleRegisterClick}
                >
                 Register Here
                </button>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
